/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as UserRouteRouteImport } from './app/routes/_user/route'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as UserProfileRouteImport } from './app/routes/_user/profile'
import { Route as UserCertificatesRouteImport } from './app/routes/_user/certificates'
import { Route as authVerifyEmailRouteImport } from './app/routes/(auth)/verify-email'
import { Route as authSignInRouteImport } from './app/routes/(auth)/sign-in'
import { Route as authResetPasswordRouteImport } from './app/routes/(auth)/reset-password'
import { Route as authRegisterRouteImport } from './app/routes/(auth)/register'
import { Route as authForgotPasswordRouteImport } from './app/routes/(auth)/forgot-password'
import { Route as UserCoursesRouteRouteImport } from './app/routes/_user/courses/route'
import { Route as UserCoursesIndexRouteImport } from './app/routes/_user/courses/index'
import { Route as UserPaymentSuccessRouteImport } from './app/routes/_user/payment/success'
import { Route as UserPaymentSelectCourseRouteImport } from './app/routes/_user/payment/select-course'
import { Route as UserPaymentCancelRouteImport } from './app/routes/_user/payment/cancel'
import { Route as UserCoursesRetryQuizRouteImport } from './app/routes/_user/courses/retry-quiz'
import { Route as UserCoursesQuizGradingRouteImport } from './app/routes/_user/courses/quiz-grading'
import { Route as UserCoursesQuizRouteImport } from './app/routes/_user/courses/quiz'
import { Route as UserCoursesPlyerRouteImport } from './app/routes/_user/courses/plyer'

const UserRouteRoute = UserRouteRouteImport.update({
  id: '/_user',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserProfileRoute = UserProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => UserRouteRoute,
} as any)
const UserCertificatesRoute = UserCertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => UserRouteRoute,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/(auth)/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authRegisterRoute = authRegisterRouteImport.update({
  id: '/(auth)/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const UserCoursesRouteRoute = UserCoursesRouteRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => UserRouteRoute,
} as any)
const UserCoursesIndexRoute = UserCoursesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserCoursesRouteRoute,
} as any)
const UserPaymentSuccessRoute = UserPaymentSuccessRouteImport.update({
  id: '/payment/success',
  path: '/payment/success',
  getParentRoute: () => UserRouteRoute,
} as any)
const UserPaymentSelectCourseRoute = UserPaymentSelectCourseRouteImport.update({
  id: '/payment/select-course',
  path: '/payment/select-course',
  getParentRoute: () => UserRouteRoute,
} as any)
const UserPaymentCancelRoute = UserPaymentCancelRouteImport.update({
  id: '/payment/cancel',
  path: '/payment/cancel',
  getParentRoute: () => UserRouteRoute,
} as any)
const UserCoursesRetryQuizRoute = UserCoursesRetryQuizRouteImport.update({
  id: '/retry-quiz',
  path: '/retry-quiz',
  getParentRoute: () => UserCoursesRouteRoute,
} as any)
const UserCoursesQuizGradingRoute = UserCoursesQuizGradingRouteImport.update({
  id: '/quiz-grading',
  path: '/quiz-grading',
  getParentRoute: () => UserCoursesRouteRoute,
} as any)
const UserCoursesQuizRoute = UserCoursesQuizRouteImport.update({
  id: '/quiz',
  path: '/quiz',
  getParentRoute: () => UserCoursesRouteRoute,
} as any)
const UserCoursesPlyerRoute = UserCoursesPlyerRouteImport.update({
  id: '/plyer',
  path: '/plyer',
  getParentRoute: () => UserCoursesRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/courses': typeof UserCoursesRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/register': typeof authRegisterRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/certificates': typeof UserCertificatesRoute
  '/profile': typeof UserProfileRoute
  '/courses/plyer': typeof UserCoursesPlyerRoute
  '/courses/quiz': typeof UserCoursesQuizRoute
  '/courses/quiz-grading': typeof UserCoursesQuizGradingRoute
  '/courses/retry-quiz': typeof UserCoursesRetryQuizRoute
  '/payment/cancel': typeof UserPaymentCancelRoute
  '/payment/select-course': typeof UserPaymentSelectCourseRoute
  '/payment/success': typeof UserPaymentSuccessRoute
  '/courses/': typeof UserCoursesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/register': typeof authRegisterRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/certificates': typeof UserCertificatesRoute
  '/profile': typeof UserProfileRoute
  '/courses/plyer': typeof UserCoursesPlyerRoute
  '/courses/quiz': typeof UserCoursesQuizRoute
  '/courses/quiz-grading': typeof UserCoursesQuizGradingRoute
  '/courses/retry-quiz': typeof UserCoursesRetryQuizRoute
  '/payment/cancel': typeof UserPaymentCancelRoute
  '/payment/select-course': typeof UserPaymentSelectCourseRoute
  '/payment/success': typeof UserPaymentSuccessRoute
  '/courses': typeof UserCoursesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_user': typeof UserRouteRouteWithChildren
  '/_user/courses': typeof UserCoursesRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/register': typeof authRegisterRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/_user/certificates': typeof UserCertificatesRoute
  '/_user/profile': typeof UserProfileRoute
  '/_user/courses/plyer': typeof UserCoursesPlyerRoute
  '/_user/courses/quiz': typeof UserCoursesQuizRoute
  '/_user/courses/quiz-grading': typeof UserCoursesQuizGradingRoute
  '/_user/courses/retry-quiz': typeof UserCoursesRetryQuizRoute
  '/_user/payment/cancel': typeof UserPaymentCancelRoute
  '/_user/payment/select-course': typeof UserPaymentSelectCourseRoute
  '/_user/payment/success': typeof UserPaymentSuccessRoute
  '/_user/courses/': typeof UserCoursesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/courses'
    | '/forgot-password'
    | '/register'
    | '/reset-password'
    | '/sign-in'
    | '/verify-email'
    | '/certificates'
    | '/profile'
    | '/courses/plyer'
    | '/courses/quiz'
    | '/courses/quiz-grading'
    | '/courses/retry-quiz'
    | '/payment/cancel'
    | '/payment/select-course'
    | '/payment/success'
    | '/courses/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/register'
    | '/reset-password'
    | '/sign-in'
    | '/verify-email'
    | '/certificates'
    | '/profile'
    | '/courses/plyer'
    | '/courses/quiz'
    | '/courses/quiz-grading'
    | '/courses/retry-quiz'
    | '/payment/cancel'
    | '/payment/select-course'
    | '/payment/success'
    | '/courses'
  id:
    | '__root__'
    | '/'
    | '/_user'
    | '/_user/courses'
    | '/(auth)/forgot-password'
    | '/(auth)/register'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(auth)/verify-email'
    | '/_user/certificates'
    | '/_user/profile'
    | '/_user/courses/plyer'
    | '/_user/courses/quiz'
    | '/_user/courses/quiz-grading'
    | '/_user/courses/retry-quiz'
    | '/_user/payment/cancel'
    | '/_user/payment/select-course'
    | '/_user/payment/success'
    | '/_user/courses/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UserRouteRoute: typeof UserRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authRegisterRoute: typeof authRegisterRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_user': {
      id: '/_user'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UserRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user/profile': {
      id: '/_user/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof UserProfileRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/_user/certificates': {
      id: '/_user/certificates'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof UserCertificatesRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user/courses': {
      id: '/_user/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof UserCoursesRouteRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/_user/courses/': {
      id: '/_user/courses/'
      path: '/'
      fullPath: '/courses/'
      preLoaderRoute: typeof UserCoursesIndexRouteImport
      parentRoute: typeof UserCoursesRouteRoute
    }
    '/_user/payment/success': {
      id: '/_user/payment/success'
      path: '/payment/success'
      fullPath: '/payment/success'
      preLoaderRoute: typeof UserPaymentSuccessRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/_user/payment/select-course': {
      id: '/_user/payment/select-course'
      path: '/payment/select-course'
      fullPath: '/payment/select-course'
      preLoaderRoute: typeof UserPaymentSelectCourseRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/_user/payment/cancel': {
      id: '/_user/payment/cancel'
      path: '/payment/cancel'
      fullPath: '/payment/cancel'
      preLoaderRoute: typeof UserPaymentCancelRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/_user/courses/retry-quiz': {
      id: '/_user/courses/retry-quiz'
      path: '/retry-quiz'
      fullPath: '/courses/retry-quiz'
      preLoaderRoute: typeof UserCoursesRetryQuizRouteImport
      parentRoute: typeof UserCoursesRouteRoute
    }
    '/_user/courses/quiz-grading': {
      id: '/_user/courses/quiz-grading'
      path: '/quiz-grading'
      fullPath: '/courses/quiz-grading'
      preLoaderRoute: typeof UserCoursesQuizGradingRouteImport
      parentRoute: typeof UserCoursesRouteRoute
    }
    '/_user/courses/quiz': {
      id: '/_user/courses/quiz'
      path: '/quiz'
      fullPath: '/courses/quiz'
      preLoaderRoute: typeof UserCoursesQuizRouteImport
      parentRoute: typeof UserCoursesRouteRoute
    }
    '/_user/courses/plyer': {
      id: '/_user/courses/plyer'
      path: '/plyer'
      fullPath: '/courses/plyer'
      preLoaderRoute: typeof UserCoursesPlyerRouteImport
      parentRoute: typeof UserCoursesRouteRoute
    }
  }
}

interface UserCoursesRouteRouteChildren {
  UserCoursesPlyerRoute: typeof UserCoursesPlyerRoute
  UserCoursesQuizRoute: typeof UserCoursesQuizRoute
  UserCoursesQuizGradingRoute: typeof UserCoursesQuizGradingRoute
  UserCoursesRetryQuizRoute: typeof UserCoursesRetryQuizRoute
  UserCoursesIndexRoute: typeof UserCoursesIndexRoute
}

const UserCoursesRouteRouteChildren: UserCoursesRouteRouteChildren = {
  UserCoursesPlyerRoute: UserCoursesPlyerRoute,
  UserCoursesQuizRoute: UserCoursesQuizRoute,
  UserCoursesQuizGradingRoute: UserCoursesQuizGradingRoute,
  UserCoursesRetryQuizRoute: UserCoursesRetryQuizRoute,
  UserCoursesIndexRoute: UserCoursesIndexRoute,
}

const UserCoursesRouteRouteWithChildren =
  UserCoursesRouteRoute._addFileChildren(UserCoursesRouteRouteChildren)

interface UserRouteRouteChildren {
  UserCoursesRouteRoute: typeof UserCoursesRouteRouteWithChildren
  UserCertificatesRoute: typeof UserCertificatesRoute
  UserProfileRoute: typeof UserProfileRoute
  UserPaymentCancelRoute: typeof UserPaymentCancelRoute
  UserPaymentSelectCourseRoute: typeof UserPaymentSelectCourseRoute
  UserPaymentSuccessRoute: typeof UserPaymentSuccessRoute
}

const UserRouteRouteChildren: UserRouteRouteChildren = {
  UserCoursesRouteRoute: UserCoursesRouteRouteWithChildren,
  UserCertificatesRoute: UserCertificatesRoute,
  UserProfileRoute: UserProfileRoute,
  UserPaymentCancelRoute: UserPaymentCancelRoute,
  UserPaymentSelectCourseRoute: UserPaymentSelectCourseRoute,
  UserPaymentSuccessRoute: UserPaymentSuccessRoute,
}

const UserRouteRouteWithChildren = UserRouteRoute._addFileChildren(
  UserRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UserRouteRoute: UserRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authRegisterRoute: authRegisterRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
